import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { sanitizeEmail, validateEmail } from '../utils/validation';
import './NewsletterInline.css';

const NewsletterInline = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const cleanEmail = sanitizeEmail(email);
    if (!validateEmail(cleanEmail)) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    setStatus('loading');

    try {
      const { error } = await supabase
        .from('newsletter_subscribers')
        .insert({ email: cleanEmail });

      if (error) {
        // Duplicate email (unique constraint) — treat as success
        if (error.code === '23505') {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } else {
        setStatus('success');
      }

      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    } catch {
      setStatus('error');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  const isFormDisabled = status === 'loading';

  const getButtonText = () => {
    switch (status) {
      case 'loading':
        return '...';
      case 'success':
        return 'subscribed!';
      case 'error':
        return 'try again';
      default:
        return 'subscribe';
    }
  };

  return (
    <div className="newsletter-inline">
      <form className="newsletter-inline-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="newsletter-inline-input"
          required
          disabled={isFormDisabled}
        />
        <button type="submit" className="newsletter-inline-button" disabled={isFormDisabled}>
          {getButtonText()}
        </button>
      </form>
    </div>
  );
};

export default NewsletterInline;
